import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import animate from "animate.css";
import BaiduMap from 'vue-baidu-map'

//css3动画
Vue.use(animate);
Vue.config.productionTip = false;
// 引入UI库
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'm51z2CE0OA1KXeXmV780b63crEWnsZyT'
})
Vue.prototype.$bus = new Vue()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
